/**
 * Formats a timestamp in seconds to HH:MM:SS or MM:SS format
 * Used for displaying video timestamps in chat messages
 *
 * @param seconds - The timestamp in seconds (as string or number)
 * @returns Formatted timestamp string (e.g., "01:23:45" or "12:34")
 *
 * @example
 * formatTimestamp("3665") // Returns "01:01:05"
 * formatTimestamp("125")  // Returns "02:05"
 */
export const formatTimestamp = (seconds: string | number): string => {
  const totalSeconds =
    typeof seconds === 'string' ? parseInt(seconds, 10) : seconds;
  const hours = Math.floor(totalSeconds / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const remainingSeconds = totalSeconds % 60;

  if (hours > 0) {
    return `${hours.toString().padStart(2, '0')}:${minutes
      .toString()
      .padStart(2, '0')}:${remainingSeconds.toString().padStart(2, '0')}`;
  }
  return `${minutes
    .toString()
    .padStart(2, '0')}:${remainingSeconds.toString().padStart(2, '0')}`;
};
